import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading } from '../../components';

import css from './ListingPage.module.css';
import moment from 'moment';

const hasValue = value => value !== null && typeof value !== 'undefined' && value !== '';

const getExtendedDataValue = (publicData, metadata, key) => {
  const publicDataValue = publicData?.[key];
  const metadataValue = metadata?.[key];
  return hasValue(publicDataValue) ? publicDataValue : metadataValue;
};

const formatDateMilled = dateMilled => {
  if (!hasValue(dateMilled)) {
    return null;
  }

  const parsedDate =
    typeof dateMilled === 'number'
      ? moment.unix(dateMilled)
      : moment.isMoment(dateMilled)
      ? dateMilled
      : moment(dateMilled);

  return parsedDate.isValid() ? parsedDate.format('Do MMM YYYY') : null;
};

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const value = getExtendedDataValue(publicData, metadata, key);

    if (isDetail && isTargetListingType && isTargetCategory && hasValue(value)) {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long' || schemaType === 'text'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);

  return existingListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {existingListingFields.map(detail => (
          <li key={detail.key} className={css.detailsRow}>
            <span className={css.detailLabel}>{detail.label}</span>
            <span>{detail.value}</span>
          </li>
        ))}
      </ul>
      <span className={css.detailsRow}>
        <span className={css.detailLabel}>
          <FormattedMessage id="ListingPage.dateMilled" />
        </span>
        <span>{formatDateMilled(publicData?.date_milled)}</span>
      </span>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
